module.exports = __webpack_public_path__ + "38e388c68e8b3c4d93c9e7bbecac1674.png";